import React, { useState } from 'react';
import { Button, Form, Input, notification } from 'antd';
import { useCheckUniqueBrandCode, checkUniqueBrandCode } from '../../hooks/useCompanies';

const formItemLayout = {
    labelCol: {
        xs: {
            span: 24,
        },
        sm: {
            span: 8,
        },
    },
    wrapperCol: {
        xs: {
            span: 24,
        },
        sm: {
            span: 16,
        },
    },
};
const tailFormItemLayout = {
    wrapperCol: {
        xs: {
            span: 24,
            offset: 0,
        },
        sm: {
            span: 16,
            offset: 8,
        },
    },
};
const BrandForm = props => {
    const [form] = Form.useForm();
    const [api, contextHolder] = notification.useNotification();
    const [isBrandCodeUnique, setBrandCodeUnique] = useState(false);
    const onSuccess = resp => {
        if (!resp.data.exists) return setBrandCodeUnique(true);
        else {
            setBrandCodeUnique(false);
            return api['warning']({
                message: `Entered Brand Code already exists under ${resp.data?.brandName}`,
            });
        }
    };
    const { mutate: checkBrandCodeExists } = useCheckUniqueBrandCode(onSuccess);

    const onFinish = async values => {
        await checkUniqueBrandCode(values.brandCode).then(resp => {
            if (!resp.data?.exists) return props.onFinish(values);
        });
    };
    return (
        <div>
            {contextHolder}
            <h2>Add brand</h2>
            <Form
                form={form}
                name="register"
                onFinish={onFinish}
                initialValues={{
                    prefix: '+91',
                }}
                {...formItemLayout}
                // scrollToFirstError
            >
                <Form.Item
                    name="brandName"
                    label="Brand Name"
                    rules={[
                        {
                            required: true,
                            message: 'Please enter your brand name!',
                        },
                        {
                            validator: (_, value) => (value && !value.trim() ? Promise.reject(new Error('No spaces allowed')) : Promise.resolve()),
                        },
                    ]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    name="brandCode"
                    label="Brand Code"
                    rules={[
                        {
                            required: true,
                            message: 'Please enter your brand code!',
                        },
                        {
                            min: 3,
                            message: 'Company code must be at least 3 characters!',
                        },
                        {
                            validator: (_, value) => (value && !value.trim() ? Promise.reject(new Error('No spaces allowed')) : Promise.resolve()),
                        },
                    ]}
                >
                    <Input onBlur={e => e.target.value && checkBrandCodeExists(e.target.value)} />
                </Form.Item>
                <Form.Item {...tailFormItemLayout}>
                    <Button type="primary" htmlType="submit" disabled={!isBrandCodeUnique}>
                        ok
                    </Button>
                    <Button
                        type="default"
                        onClick={() => {
                            props.setmodalContent('');
                        }}
                        style={{
                            marginLeft: '10px',
                        }}
                    >
                        Cancel
                    </Button>
                </Form.Item>
            </Form>
        </div>
    );
};

export default BrandForm;
